export const EXIBIR_CARREGANDO = 'EXIBIR_CARREGANDO';

export const exibirCarregando = (carregando) => {
  return {
    type: EXIBIR_CARREGANDO,
    payload: carregando,
  };
};